import CloseIcon from '@mui/icons-material/Close';
import {
  Box,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';
import React from 'react';

import SummaryTab from './tabs/SummaryTab';
import { DocumentConciliationRateHistory } from './types';
import { useRateHistory } from './useRateHistory';

interface InfoRowDetailDialogProps {
  open: boolean;
  onClose: () => void;
  label: string;
  value: string | null;
  documentId?: string;
  rateHistory?: DocumentConciliationRateHistory | null;
  onHistoryLoaded?: (history: DocumentConciliationRateHistory) => void;
}

const InfoRowDetailDialog: React.FC<InfoRowDetailDialogProps> = ({
  open,
  onClose,
  label,
  documentId,
  rateHistory: propRateHistory,
  onHistoryLoaded,
}) => {
  const { loading, error, history } = useRateHistory({
    open,
    documentId,
    propRateHistory,
    onHistoryLoaded,
  });

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          pb: 1,
        }}
      >
        <Typography variant="h6">{label}</Typography>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        {loading ? (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              minHeight: '200px',
            }}
          >
            <CircularProgress />
          </Box>
        ) : error ? (
          <Box sx={{ py: 3, textAlign: 'center' }}>
            <Typography color="error">{error}</Typography>
          </Box>
        ) : !history ? (
          <Box sx={{ py: 3, textAlign: 'center' }}>
            <Typography color="text.secondary">
              No hay información disponible
            </Typography>
          </Box>
        ) : (
          history && <SummaryTab history={history} />
        )}
      </DialogContent>
    </Dialog>
  );
};

export default InfoRowDetailDialog;
